import { withStyles } from "@material-ui/core/styles";
import { Icon, IconButton, Popover, Slider as SliderComponent } from "@material-ui/core";
import { app } from "js/namespaces";
import { Gap30 } from "js/react/components/Gap";
import React, { Component } from "react";
import { fontControlStyles } from "../../themeEditor_style";
import TextTransform from "./TextTransform";

class Slider extends Component {
    constructor(props) {
        super(props);

        this.state = {
            value: this.props.value
        };
    }
    handleChange = (event, val) => {
        this.setState({ value: val });
    };

    render() {
        const { name, label, min, max, step, unit, update, classes } = this.props;

        return (
            <div className={classes.fontSettingsSlider}>
                <label>{label}</label>
                <div>
                    <SliderComponent
                        style={{ width: "75%", display: "inline-block" }}
                        value={this.state.value}
                        min={min}
                        max={max}
                        step={step}
                        aria-labelledby={label}
                        onChange={this.handleChange}
                        onChangeCommitted={(event, value) => {
                            update({ [name]: value });
                        }}
                    />
                    <span
                        style={{
                            padding: 6,
                            fontSize: 16,
                            position: "relative",
                            top: 4,
                            left: 6
                        }}
                    >
                        {(decimalArr =>
                            decimalArr[1]
                                ? this.state.value.toFixed(decimalArr[1].length)
                                : this.state.value)(step.toString().split("."))}{" "}
                        {unit && unit}
                    </span>
                </div>
            </div>
        );
    }
}

class FontSettings extends Component {
    constructor() {
        super();

        this.state = {
            anchorEl: null,
            selectedIndex: 1,
            fontFaces: []
        };
    }

    handleClickListItem = event => {
        this.setState({ anchorEl: event.currentTarget });
    };

    handleClose = () => {
        this.setState({ anchorEl: null });
    };

    render() {
        const { classes, style, theme, update } = this.props;

        return (
            <div className={classes.fontSettings}>
                <IconButton
                    aria-haspopup="true"
                    onClick={this.handleClickListItem}
                    aria-label="Font Settings"
                >
                    <Icon classes={{ root: classes.settingsColor }}>
                        more_vert
                    </Icon>
                </IconButton>
                <Popover
                    disableEnforceFocus
                    anchorOrigin={{
                        vertical: "bottom",
                        horizontal: "center"
                    }}
                    transformOrigin={{
                        vertical: "top",
                        horizontal: "center"
                    }}
                    anchorEl={this.state.anchorEl}
                    open={Boolean(this.state.anchorEl)}
                    classes={{
                        paper: classes.fontSettingsPaper
                    }}
                    onClose={this.handleClose}
                >
                    <div>
                        <Gap30 />
                        <Slider
                            min={-0.1}
                            max={0.3}
                            step={0.01}
                            value={theme[`font${style}LetterSpacing`]}
                            name={`font${style}LetterSpacing`}
                            label="Letter Spacing"
                            classes={classes}
                            update={value => {
                                app.wordWidthCache = {};
                                update(value);
                            }}
                        />
                        <Slider
                            min={1}
                            max={3}
                            step={0.1}
                            value={theme[`font${style}LineHeight`]}
                            name={`font${style}LineHeight`}
                            label="Line Height"
                            classes={classes}
                            update={update}
                        />
                        <Slider
                            min={50}
                            max={150}
                            step={1}
                            value={theme[`font${style}Scaling`]}
                            name={`font${style}Scaling`}
                            label="Font Scale"
                            classes={classes}
                            unit="%"
                            update={update}
                        />

                        <TextTransform
                            label="Case"
                            values={[
                                { label: "Auto", value: "auto" },
                                { label: "Uppercase", value: "uppercase" },
                                { label: "Lowercase", value: "lowercase" }
                            ]}
                            selected={theme[`font${style}TextTransform`]}
                            name={`font${style}TextTransform`}
                            update={update}
                        />
                    </div>
                </Popover>
            </div>
        );
    }
}

export default withStyles(fontControlStyles)(FontSettings);
